import ButtonBase from '@material-ui/core/ButtonBase';
import IconArrow from 'assets/svg/icons/arrow.inline.svg';
import React from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
import tw, { css } from 'twin.macro';

const baseStyles = css`
	${tw`w-full relative flex items-center justify-center max-w-220 py-10 rounded-10`};
	
	&:disabled {
		${tw`bg-grey-F text-grey-7`}
		p {${tw`text-grey-7`}}
	}
`;

const primaryStyles = css`
	${tw`bg-primary`};
	
	svg { ${tw`mr-10 fill-current stroke-current text-light w-14 h-14`} };
	p { ${tw`text-light text-12`} };
`;

const secondaryStyles = css`
	${tw`h-30 py-07`};
	p { ${tw`text-light`} };
`;

const smallStyles = css`
	${tw`py-05 bg-grey-D max-w-150 mt-15`};
	p { ${tw`text-grey-3`} };
`;

const verySmallStyles = css`
	${tw`py-05 bg-grey-D max-w-100`};
	p { ${tw`text-grey-3`} };
`;

const textStyles = css`
	${tw`w-30 mx-05 p-05 font-normal`};
`;

const animatedStyles = css`
	${tw`bg-primary w-full max-w-220 py-10 mb-10 mt-0`};
	p { ${tw`text-light text-12`} };

	transition: all 0.5s;
`;

const animatedHiddenStyles = css`
	${tw`h-0! w-0! p-0! m-0! opacity-0!`};

	transition: all 0.5s;
`;

const panelStyles = css`
	${tw`h-120 flex-col justify-center m-10 max-w-300`};
`;

const plateStyles = css`
	${tw`justify-start rounded-0 pl-12 pr-05 py-07 max-w-full`};
`;

const fixedBottomStyles = css`
	${tw`fixed bottom-0 mb-nav landscape:mb-0 z-10`};
`;

const bottomStyles = css`
	${fixedBottomStyles};
	${tw`max-w-full justify-center rounded-0 pl-12 pr-05 py-07 text-primary text-12 bg-grey-F h-nav px-15`};
`;

export default function Button({ Icon, iconStyles, loading, children, ...props }) {
	const { primary, secondary, small, verySmall, text, panel, plate, fixed, bottom, animated, animatedHidden, ...other } = props;

	return (
		<ButtonBase css={[
			baseStyles,
			primary && primaryStyles,
			secondary && secondaryStyles,
			small && smallStyles,
			verySmall && verySmallStyles,
			text && textStyles,
			panel && panelStyles,
			plate && plateStyles,
			fixed && fixedBottomStyles,
			bottom && bottomStyles,
			animated && animatedStyles,
			animatedHidden && animatedHiddenStyles
		]} {...other}>
			{loading ? <PulseLoader color='#F8F8F8' size={8} /> : children}
			{bottom && <Icon className={iconStyles} />}
		</ButtonBase>
	);
}

Button.defaultProps = {
	Icon: IconArrow,
	iconStyles: 'fill-current text-primary w-15 h-15 absolute right-0 mx-15'
};
